import { DO_OR_DUMP_UPSELL_BUSINESS_PUSH, DO_OR_DUMP_UPSELL_NICHE } from "@/lib/do-or-dump-upsells";

/** Legacy Stripe / DB line id for the old AI plan — still recognized on historical orders. */
export const LEGACY_BUSINESS_PUSH_LINE_ID = "person_deep";

export type OrderLineItemRow = { id?: string; label?: string; amount_cents?: number };

export function parseOrderLineItems(raw: unknown): OrderLineItemRow[] {
  if (!Array.isArray(raw)) return [];
  return raw as OrderLineItemRow[];
}

export function orderHasExpertAudit(items: unknown): boolean {
  return parseOrderLineItems(items).some((x) => x.id === DO_OR_DUMP_UPSELL_NICHE.id);
}

export function orderHasBusinessPush(items: unknown): boolean {
  return parseOrderLineItems(items).some(
    (x) => x.id === DO_OR_DUMP_UPSELL_BUSINESS_PUSH.id || x.id === LEGACY_BUSINESS_PUSH_LINE_ID,
  );
}
